// extracted by mini-css-extract-plugin
module.exports = {"hero_tags":"styles_hero_tags__PZ6Lw","label":"styles_label__XdL_c","tag":"styles_tag__dwVKE","activeTag":"styles_activeTag__8Kdhh"};